<template>
<div class="center-wrap">
    <div class="center-content-top">
        <centerPanel></centerPanel>
    </div>
    <div class="center-content-bottom">
        <div class="center-bottom-title">质量数据</div>
        <div class="center-bottom-echarts">
            <div class="single-line">
                <singleLine></singleLine>
            </div>
            <div class="double-line">
                <doubleLine></doubleLine>
            </div>
            <div class="progress-percent">
                <progressLine></progressLine>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import singleLine from "./centerBottom/singleLine"
import doubleLine from "./centerBottom/doubleLine"
import progressLine from './centerBottom/progressLine.vue';
import centerPanel from './centerTop/centerPanel.vue';
export default {
    name: "center-part",
    data() {
        return {

        }
    },
    components: {
        singleLine,
        doubleLine,
        progressLine,
        centerPanel
    },
    mounted() {

    },
};
</script>

<style lang="less">
.center-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .center-content-top,
    .center-content-bottom {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        //border: 1px #0054FF solid;
    }

    .center-content-top {
        font-size: 14px;
    }

    .center-bottom-title {
        padding: 8px 10px 0px;
        font-size: 18px;
        flex: 0 0 5%;
    }

    .single-line,
    .double-line,
    .progress-percent {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .center-content-top {
        flex: 0 0 75%;
    }

    .center-content-bottom {
        flex: 0 0 25%;
        margin: 0 20px;
        border: 1px #0054FF solid;
    }

    .center-bottom-echarts {
        display: flex;
        flex: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/home/centerPart.vue